/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Nahrazovač datového zdroje session
 * Stará se o aktualizaci datového zdroje s nastavením zařízení dle nového obsahu.
 */
class ReplacerSession {
  /**
   * Vytvoří nahrazovač session.
   * @param {Store} primaryStore Hlavní datový sklad ve kterém je uložen přehrávaný obsah.
   * @param {Session} session
   */
  constructor(primaryStore, session) {
    this.primaryStore = primaryStore;
    this.session = session;
  }

  /**
   * Vymění stávající obsah datového zdroje s nastavením zařízení za nový.
   * @param {ContentInfo} contentInfo
   * @returns {Promise.<Session>}
   */
  replace(contentInfo) {
    return new Promise((resolve) => {
      const { session } = contentInfo;
      // TODO Store update undefined bug
      // - Metoda update nepřepíše v paměti položky s hodnotou undefined,
      //   ale v perzistentním úložišti ano.
      // - Před jejím voláním se data vloží přes inject.
      //   Zde je ale problém, že se dodržuje identifikátor z attrs a ne z parametrů.
      // - Asi přepracovat tak, aby se používalo {onConflict: 'replace'}
      const attrs = JSON.parse(JSON.stringify(session));
      const { primaryStore } = this;
      // primaryStore.inject('session', attrs);
      // TODO: storage ukládám jinde, je to tak spravne??
      delete attrs.storage;
      return resolve(primaryStore.update('session', this.session.id, attrs));
    });
  }

  /**
   * Obnoví obsah datového zdroje s nastavením zařízení.
   * @returns {Promise.<Session>}
   */
  restore() {
    return new Promise((resolve) => {
      const { primaryStore } = this;
      const sessionId = this.session.id;
      return resolve(
        // Obnovení předchozí session.
        primaryStore
          .find('session', sessionId)
          // Vytvoření nové session, pokud se nepodařilo obnovit.
          .catch(() => primaryStore.create('session', { id: sessionId }))
      );
    });
  }
}

export default ReplacerSession;
